// extracted by mini-css-extract-plugin
export default {"area":"RenderRectangle_area__yqPd2","search-indicator":"RenderRectangle_search-indicator__E7S-c","chip":"RenderRectangle_chip__X0QH8"};